export default "__VITE_ASSET__RVN16JMA__"